/**
 * MifeLife v2 — Public footer. Dark, minimal, restrained.
 */
import React from 'react';
import { Link } from 'react-router-dom';

const COPY = {
  tr: {
    tag: 'AI yol haritanı çizer, gerçek mentörler hedeflerine ulaştırır.',
    prod: 'Ürün', urun: ['AI Analiz', 'Mentörler', 'Fiyatlandırma', 'Blog'],
    sirket: 'Şirket', sirketL: ['Hakkımızda', 'İletişim', 'Mentör başvurusu'],
    yasal: 'Yasal', yasalL: ['Gizlilik', 'KVKK', 'Kullanım Şartları'],
    rights: 'Tüm hakları saklıdır.',
  },
  en: {
    tag: 'AI draws your roadmap, real mentors get you to your goals.',
    prod: 'Product', urun: ['AI Analysis', 'Mentors', 'Pricing', 'Blog'],
    sirket: 'Company', sirketL: ['About', 'Contact', 'Become a mentor'],
    yasal: 'Legal', yasalL: ['Privacy', 'GDPR', 'Terms'],
    rights: 'All rights reserved.',
  },
  de: {
    tag: 'KI zeichnet deine Roadmap, echte Mentoren bringen dich ans Ziel.',
    prod: 'Produkt', urun: ['KI-Analyse', 'Mentoren', 'Preise', 'Blog'],
    sirket: 'Unternehmen', sirketL: ['Über uns', 'Kontakt', 'Mentor werden'],
    yasal: 'Rechtliches', yasalL: ['Datenschutz', 'DSGVO', 'AGB'],
    rights: 'Alle Rechte vorbehalten.',
  },
};

const LINK_MAP = {
  'AI Analiz': '/analiz', 'AI Analysis': '/analiz', 'KI-Analyse': '/analiz',
  'Mentörler': '/mentorler', 'Mentors': '/mentorler', 'Mentoren': '/mentorler',
  'Fiyatlandırma': '/fiyatlandirma', 'Pricing': '/fiyatlandirma', 'Preise': '/fiyatlandirma',
  'Blog': '/blog',
  'Hakkımızda': '/hakkinda', 'About': '/hakkinda', 'Über uns': '/hakkinda',
  'İletişim': '/iletisim', 'Contact': '/iletisim', 'Kontakt': '/iletisim',
  'Mentör başvurusu': '/mentor-basvuru', 'Become a mentor': '/mentor-basvuru', 'Mentor werden': '/mentor-basvuru',
  'Gizlilik': '/privacy', 'Privacy': '/privacy', 'Datenschutz': '/privacy',
  'KVKK': '/kvkk', 'GDPR': '/kvkk', 'DSGVO': '/kvkk',
  'Kullanım Şartları': '/terms', 'Terms': '/terms', 'AGB': '/terms',
};

export default function V2Footer({ lang = 'tr' }) {
  const T = COPY[lang] || COPY.tr;
  return (
    <footer className="border-t border-white/[0.06] bg-[#0a0a14] py-14 mt-20" data-testid="v2-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="text-white font-semibold tracking-tight mb-3">MifeLife</div>
          <p className="text-sm text-slate-400 leading-relaxed">{T.tag}</p>
        </div>
        <FCol title={T.prod} items={T.urun} />
        <FCol title={T.sirket} items={T.sirketL} />
        <FCol title={T.yasal} items={T.yasalL} />
      </div>
      <div className="max-w-7xl mx-auto px-5 sm:px-8 mt-10 pt-6 border-t border-white/[0.04] flex items-center justify-between text-xs text-slate-500">
        <span>© {new Date().getFullYear()} MifeLife. {T.rights}</span>
      </div>
    </footer>
  );
}

const FCol = ({ title, items }) => (
  <div>
    <div className="text-[11px] uppercase tracking-[0.18em] text-slate-500 mb-4">{title}</div>
    <ul className="space-y-2">
      {items.map((it) => (
        <li key={it}>
          <Link to={LINK_MAP[it] || '/'} className="text-sm text-slate-400 hover:text-white transition">{it}</Link>
        </li>
      ))}
    </ul>
  </div>
);
